define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/constants",
	"csi/def/Heading",
	"csi/heading/Spec",
	"csi/locale",
	"csi/reflection",
	"csi/table/matrix/ColumnVector",
	"csi/xml"
], function(declare,lang,csi,_,constants,Heading,Spec,locale,reflection,ColumnVector,xml) {

	var DIM2_HEADER_INDEX = -1;

	return declare(ColumnVector, {
		// path from view node to columns
		columnPath: "Child:IncrementDimension1Sizes",

		_increment: null,   // parent Increment node
		_isTwoDim: null,    // boolean true if the parent Increment has two dimensional sizes
		_incrementSizes: null,
		_dim1Sizes: null,
		_dim2Sizes: null,
		_dim2Type: null,

		addDependencyPaths: function(/*Heading*/h, /*String[]*/paths) {
			// summary: add any dependency paths necessary to process matrix
			paths.push("Child:IncrementDimension1Sizes");
			paths.push("Child:IncrementDimension2Sizes");
			paths.push("Child:Sizes/Child:IncrementSize");
			this.inherited(arguments);
		},

		getColumnSpecs: function(/*Context*/ctx, /*Heading*/h) {
			// show the row size at the start of each row (Dimension 2 column),
			var specs = this.inherited(arguments);

			this._getIncrementAndCacheVectors(ctx);

			// Reset the 2-d spec indices so that it will be recalculated when view refresh
			ctx.view.twoDimSpecIndices = null;

			if (this._isTwoDim && specs.length) {
				specs.unshift(new Spec({
					css: constants.CSS_TABLE_COLUMNS,
					heading: h,
					headerParams: {
						innerText: locale.getEnumName(this._dim2Type)
					},
					index: DIM2_HEADER_INDEX
				}));
			}

			return specs;
		},

		// override csi.table.matrix.Path#_getSpecIndices
		_getSpecIndices: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			// summary: return list of indices to apply with spec (Dimension1 Size) to given node (IncrementDimension)

			if (this._isTwoDim) {
				var apparelDimension = ctx.cache.getNode(nodes[0].IncrementDimension);
				var hasMatchingDimensionDependencies = _.contains(apparelDimension.DimensionDependencies, this._dim2Type);

				if (spec.index == DIM2_HEADER_INDEX && !hasMatchingDimensionDependencies) {
					//TA32053: For Not Dimensional POMs Dimension 2 Attribute should Appear Blank
					return [this.INVALID_INDEX];
				}
				else if (spec.index != DIM2_HEADER_INDEX && hasMatchingDimensionDependencies) {
					// Display 2-dimensional Increments matrix if the ApparelDimension has matching Dimension2 type dependency
					return this._getTwoDimSpecIndices(ctx, spec.index);
				}
			}

			return this.inherited(arguments);
		},

		_getTwoDimSpecIndices: function(/*Context*/ctx, /*Integer*/dim1SizeIndex) {
			//summary: (1) If not built yet, build the 2-dim spec indeces in form of vector of vectors [dim1-index, dim2-index]
			// (2) Store it on ctx.view for performances
			// (3) then returns the spec indices for that particular spec

			//Skip calculation if no changing selection on the Dimension2 Sizes switchboard
			if (ctx.view.twoDimSpecIndices) {
				return ctx.view.twoDimSpecIndices[dim1SizeIndex];
			}

			// Not cached yet, then we have to build and store the vector of vectors on ctx.view
			var indices = ctx.view.twoDimSpecIndices = [];

			var cache = ctx.cache;
			var selectedDim2Sizes = ctx.view.selectedDim2Sizes? ctx.view.selectedDim2Sizes : this._dim2Sizes;
			var mapDim2Sizes = csi.hashArray(selectedDim2Sizes, null, Number);

			var specIndices;
			var iDim1Size;
			var j;
			var k;
			for (iDim1Size = 0; iDim1Size < this._dim1Sizes.length; iDim1Size++) {
				specIndices = [];  // spec indices for one Spec (one column)

				// Initialize it to the so that each Dim1Size x Dim2Size has a cell, the holes will have indices of default
				for (k=0; k < selectedDim2Sizes.length; k++) {
					specIndices[k] = this.INVALID_INDEX;
				}

				var specDim1Size = this._dim1Sizes[iDim1Size];
				for (j=0; j < this._incrementSizes.length; j++) {
					var curIncSize = cache.getNode(this._incrementSizes[j]);
					var curProductSize = cache.getNode(curIncSize.IncrementSize);
					var curIncSizeDim1Size = curProductSize.Dimension1Size;
					var curIncSizeDim2Size = curProductSize.Dimension2Size;

					if(specDim1Size == curIncSizeDim1Size) {
						var dim2Index = mapDim2Sizes[curIncSizeDim2Size];
						if (dim2Index != null) {
							specIndices[dim2Index] = j;
						}
					}
				}

				indices[iDim1Size] = specIndices;
			}
			ctx.view.twoDimSpecIndices = indices;

			return indices[dim1SizeIndex];
		},

		_getIncrementAndCacheVectors: function(/*Context*/ctx) {
			//summary: (1) return the parent increment node (2) and cache the vectors for optimization
			this._increment = ctx.getParent();
			console.assert(!!this._increment, "Increment not found");

			this._incrementSizes = this._increment.Sizes;
			this._dim1Sizes = this._increment.IncrementDimension1Sizes;
			this._dim2Sizes = this._increment.IncrementDimension2Sizes;
			this._isTwoDim = this._dim2Sizes && this._dim2Sizes.length > 0;
			if (this._isTwoDim) {
				this._dim2Type = this._increment.Dimension2Type;
			}

			return this._increment;
		},

		_getSpecNodes: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			if (spec.index == DIM2_HEADER_INDEX) {
				// Display 2-dimensional Increments matrix if the ApparelDimension has matching Dimension2 type dependency
				var apparelDimension = ctx.cache.getNode(nodes[0].IncrementDimension);
				if(_.contains(apparelDimension.DimensionDependencies, this._dim2Type)) {
					// Filter the 2nd dimension sizes by what selected on the switchboard
					var selectedDim2Sizes = ctx.view.selectedDim2Sizes? ctx.view.selectedDim2Sizes : this._dim2Sizes;
					return ctx.cache.getNodes(selectedDim2Sizes);
				}
			}

			return null;
		},

		_renderSpec: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes, /*Number*/nColumn, /*DOMNode*/td) {
			// summary: render spec to given cell
			var hOriginal;

			// render the leading column - Dimension2 Sizes
			if (spec.index == DIM2_HEADER_INDEX) {
				hOriginal = spec.heading;

				if (!ctx.view.productSizeHeading) {
					ctx.view.productSizeHeading = lang.mixin(new Heading(), {m_id: xml.ATTR_NAME, m_right: xml.RIGHT_NONE});
					ctx.view.productSizeHeading.resolveHeading(ctx.defView.getLocaleMap(), null, reflection.getClass("ProductSize"));
				}
				spec.heading = ctx.view.productSizeHeading;
			}

			this.inherited(arguments);

			if (hOriginal) {
				spec.heading = hOriginal;
			}
		}
	});
});